import { IBrandProduct } from '@models/StockManage/BrandProduct';
import { IRegularWeak } from '@models/StockManage/RegularWeak';
import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import ProductManagementApi from 'apis/api/ProductManagement';
import { IProduct, IProductSet } from 'models/Production';
import { IProductCategory } from 'models/StockManage/CateProductManage';
import { IProductType } from 'models/StockManage/TypeProductManage';

// lấy tất cả category sản phẩm
export const getAllCategoryPros = createAsyncThunk('select/getAllCategoryPros', async () => {
  const response = await ProductManagementApi.GetProductCateList();
  return response.data;
});

// lấy nhóm sản phẩm
export const getAllTypePros = createAsyncThunk('select/getAllTypePros', async () => {
  const response = await ProductManagementApi.GetProductTypeList();
  return response.data;
});

// lấy nhãn hiệu sản phẩm
export const getAllBrandPros = createAsyncThunk('select/getAllBrandPros', async () => {
  const response = await ProductManagementApi.GetProductBrandList();
  return response.data;
});

// lấy danh sách lỗi thường gặp
export const getAllRegularWeak = createAsyncThunk('select/getAllRegularWeak', async () => {
  const response = await ProductManagementApi.GetRegularWeakListV3();
  return response.data;
});

// lấy danh sách cách xử lý
export const getAllHandleError = createAsyncThunk('select/getAllHandleError', async () => {
  const response = await ProductManagementApi.GetHandleErrorListV3();
  return response.data;
});

// lấy danh sách bộ
export const getAllProductSet = createAsyncThunk('select/getAllProductSet', async () => {
  const response = await ProductManagementApi.GetSetProductList();
  return response.data;
});

export const getDetailProductSet = createAsyncThunk('select/getDetailProductSet', async (id: number) => {
  const response = await ProductManagementApi.GetSetProductById(id);
  return response.data;
});

type TloadedData = {
  productCate: boolean;
  productType: boolean;
  productBrand: boolean;
  regularWeak: boolean;
  handleError: boolean;
};
type initialStateType = {
  loadedData: TloadedData;
  productData: Array<IProduct>;
  productCateData: Array<IProductCategory>;
  productTypeData: Array<IProductType>;
  productBrandData: Array<IBrandProduct>;
  regularWeakData: Array<IRegularWeak>;
  handleErrorData: Array<any>;
  productSetData: Array<IProductSet>;
  productSetSelected: IProductSet | null;
};

const initialState: initialStateType = {
  loadedData: {
    productCate: false,
    productType: false,
    productBrand: false,
    regularWeak: false,
    handleError: false
  },
  productData: [],
  productCateData: [],
  productTypeData: [],
  productBrandData: [],
  regularWeakData: [],
  handleErrorData: [],
  productSetData: [],
  productSetSelected: null
};

export const proccessDetailProductData = (product: IProductSet | any) => {
  const productSet = {
    ...product.productSet
  };

  const arrProduct: any =
    product?.details?.map(productD => ({
      maSanPham: productD.productInfo.maSanPham,
      productId: productD.productInfo.id,
      quantity: productD.quantity,
      nameDisplay: productD.productInfo.name
    })) || [];

  productSet['details'] = arrProduct;
  return productSet;
};

const productionSlide = createSlice({
  name: 'production',
  initialState: initialState,
  reducers: {
    resetState: state => {
      state.productData = [];
      state.productCateData = [];
    },
    slide: state => {
      state.productData = [];
    },
    updateProductSet: (state, action: PayloadAction<IProductSet>) => {
      const checkExist = state.productSetData.findIndex(product => product.maSanPham === action.payload.maSanPham);
      console.log('updateProductSet 0', checkExist, action.payload);
      if (checkExist > -1) {
        // cập nhật mới nếu đã tồn tại cái cũ
        state.productSetData[checkExist] = { ...action.payload, loadedDetail: true };
        if (state.productSetSelected) {
          state.productSetSelected = { ...action.payload, loadedDetail: true };
        }
        return;
      }
    },
    // set chọn 1 bộ sp thông qua mã sản phẩm
    updateSelectProductSet: (state, action: PayloadAction<string | null>) => {
      // state.orderCreateBase = null;
      if (action.payload === null) {
        state.productSetSelected = null;
      } else {
        const productSetFind = state.productSetData.find(product => product.maSanPham === action.payload);
        // tìm device đã chọn theo plate và add nó vào xe chọn
        if (productSetFind) {
          state.productSetSelected = { ...productSetFind };
        } else {
          state.productSetSelected = null;
        }
      }
    }
  },
  extraReducers: builder => {
    builder.addCase(getAllCategoryPros.fulfilled, (state, action) => {
      console.log('addCase getAllCategoryPros');
      state.loadedData.productCate = true;
      state.productCateData = action.payload?.data.sort((a,b ) => a.index - b.index) || [];
    });
    builder.addCase(getAllTypePros.fulfilled, (state, action) => {
      console.log('addCase getAllTypePros');
      state.loadedData.productType = true;
      state.productTypeData = action.payload?.data || [];
    });
    builder.addCase(getAllBrandPros.fulfilled, (state, action) => {
      console.log('addCase getAllBrandPros');
      state.loadedData.productBrand = true;
      state.productBrandData = action.payload?.data || [];
    });
    builder.addCase(getAllRegularWeak.fulfilled, (state, action) => {
      console.log('addCase regularWeak');
      state.loadedData.regularWeak = true;
      state.regularWeakData = action.payload?.data || [];
    });
    builder.addCase(getAllHandleError.fulfilled, (state, action) => {
      console.log('addCase handleError');
      state.loadedData.handleError = true;
      state.handleErrorData = action.payload?.data || [];
    });
    builder.addCase(getAllProductSet.fulfilled, (state, action) => {
      console.log('addCase getAllProductSet');
      state.productSetData =
        action.payload?.data?.sort((a, b) =>
          a.name.localeCompare(b.name, 'vi', { sensitivity: 'variant', caseFirst: 'upper' })
        ) || [];

      // sort<IProductSet>(action.payload?.data || []).asc(u => u.name); // thêm sort..
    });
    builder.addCase(getDetailProductSet.fulfilled, (state, action) => {
      console.log('addCase getAlgetDetailProductSetlProductSet');
      action.payload = proccessDetailProductData(action.payload?.data);
      // cập nhật 1 phần tử trong store
      productionSlide.caseReducers.updateProductSet(state, action);
    });
  }
});

export const { resetState, updateProductSet, updateSelectProductSet } = productionSlide.actions;

export default productionSlide.reducer;
